
import * as am9sdC1waHlzaWNz from 'jolt-physics';
import * as d2FzbTpqcy1zdHJpbmc from './awake-studio-app-studio.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    function doNotUseRequire() {
        throw new Error("Do not use top-level require. Prefer to use JS import or define your own require instead. Read more: https://kotl.in/r9txlt")
    }

    var require = new Proxy((function() {}), {
        apply(target, thisArg, argumentsList) {
            if (globalThis.require != null) {
                return globalThis.require.apply(thisArg, argumentsList);
            } else {
                doNotUseRequire();
            }
        },
        get(target, prop, receiver) {
            if (globalThis.require != null) {
                return Reflect.get(globalThis.require, prop);
            } else {
                doNotUseRequire();
            }
        },
    });
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_am9sdC1waHlzaWNz_ = am9sdC1waHlzaWNz;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.intToExternref' : (x) => x,
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.doubleToExternref' : (x) => x,
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.longToExternref' : (x) => x,
    'kotlin.wasm.internal.kotlinUShortToJsNumberUnsafe' : (x) => x & 0xFFFF,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.newJsArray' : () => [],
    'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_0' : (f, trampoline) => getCachedJsObject(f, () => trampoline(f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.js.jsArrayGet' : (array, index) => array[index],
    'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
    'kotlin.js.JsArray_$external_fun' : () => new Array(),
    'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsNumber_$external_class_instanceof' : (x) => typeof x === 'number',
    'kotlin.js.JsNumber_$external_class_get' : () => JsNumber,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_1' : (f, trampoline) => getCachedJsObject(f, (p0) => trampoline(f, p0)),
    'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
    'kotlin.js.Promise_$external_class_instanceof' : (x) => x instanceof Promise,
    'kotlin.js.Promise_$external_class_get' : () => Promise,
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.Date_$external_fun' : () => new Date(),
    'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlin.uuid.cryptoGetRandomValues' : (size) => crypto.getRandomValues(new Int8Array(size)),
    'kotlin.uuid.get' : (array, index) => array[index],
    'org.khronos.webgl.getMethodImplForUint8ClampedArray' : (obj, index) => obj[index],
    'org.khronos.webgl.getMethodImplForInt32Array' : (obj, index) => obj[index],
    'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.getMethodImplForUint8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.setMethodImplForInt8Array' : (obj, index, value) => { obj[index] = value; },
    'org.khronos.webgl.setMethodImplForInt32Array' : (obj, index, value) => { obj[index] = value; },
    'org.khronos.webgl.Int8Array_$external_fun' : (p0) => new Int8Array(p0),
    'org.khronos.webgl.Int8Array_$external_fun_1' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
    'org.khronos.webgl.ArrayBuffer_$external_fun' : (p0) => new ArrayBuffer(p0),
    'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'org.khronos.webgl.slice_$external_fun' : (_this, p0, p1, isDefault0) => _this.slice(p0, isDefault0 ? undefined : p1, ),
    'org.khronos.webgl.Int32Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Int32Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.Uint8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter_1' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'org.khronos.webgl.byteOffset_$external_prop_getter' : (_this) => _this.byteOffset,
    'org.khronos.webgl.byteLength_$external_prop_getter_1' : (_this) => _this.byteLength,
    'org.w3c.dom.css.cssText_$external_prop_setter' : (_this, v) => _this.cssText = v,
    'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.clientX_$external_prop_getter' : (_this) => _this.clientX,
    'org.w3c.dom.events.clientY_$external_prop_getter' : (_this) => _this.clientY,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
    'org.w3c.dom.events.MouseEvent_$external_class_instanceof' : (x) => x instanceof MouseEvent,
    'org.w3c.dom.events.MouseEvent_$external_class_get' : () => MouseEvent,
    'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
    'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
    'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
    'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
    'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
    'org.w3c.dom.events.deltaMode_$external_prop_getter' : (_this) => _this.deltaMode,
    'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
    'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
    'org.w3c.dom.width_$external_prop_getter' : (_this) => _this.width,
    'org.w3c.dom.height_$external_prop_getter' : (_this) => _this.height,
    'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
    'org.w3c.dom.open_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.open(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
    'org.w3c.dom.width_$external_prop_getter_1' : (_this) => _this.width,
    'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.height_$external_prop_getter_1' : (_this) => _this.height,
    'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.getContext_$external_fun' : (_this, p0, p1) => _this.getContext(p0, ...p1),
    'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
    'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
    'org.w3c.dom.CanvasRenderingContext2D_$external_class_instanceof' : (x) => x instanceof CanvasRenderingContext2D,
    'org.w3c.dom.CanvasRenderingContext2D_$external_class_get' : () => CanvasRenderingContext2D,
    'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.readyState_$external_prop_getter' : (_this) => _this.readyState,
    'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
    'org.w3c.dom.binaryType_$external_prop_setter' : (_this, v) => _this.binaryType = v,
    'org.w3c.dom.close_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.close(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'org.w3c.dom.send_$external_fun' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.send_$external_fun_1' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.OPEN_$external_prop_getter' : (_this) => _this.OPEN,
    'org.w3c.dom.Companion_$external_object_getInstance' : () => WebSocket,
    'org.w3c.dom.data_$external_prop_getter_1' : (_this) => _this.data,
    'org.w3c.dom.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.reason_$external_prop_getter' : (_this) => _this.reason,
    'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
    'org.w3c.dom.createImageBitmap_$external_fun' : (_this, p0, p1, isDefault0) => _this.createImageBitmap(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.pathname_$external_prop_getter' : (_this) => _this.pathname,
    'org.w3c.dom.search_$external_prop_getter' : (_this) => _this.search,
    'org.w3c.dom.hash_$external_prop_getter' : (_this) => _this.hash,
    'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
    'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
    'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.width_$external_prop_getter_2' : (_this) => _this.width,
    'org.w3c.dom.height_$external_prop_getter_2' : (_this) => _this.height,
    'org.w3c.dom.identifier_$external_prop_getter' : (_this) => _this.identifier,
    'org.w3c.dom.clientX_$external_prop_getter' : (_this) => _this.clientX,
    'org.w3c.dom.clientY_$external_prop_getter' : (_this) => _this.clientY,
    'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.dom.drawImage_$external_fun' : (_this, p0, p1, p2) => _this.drawImage(p0, p1, p2),
    'org.w3c.dom.getImageData_$external_fun' : (_this, p0, p1, p2, p3) => _this.getImageData(p0, p1, p2, p3),
    'org.w3c.dom.getItem_$external_fun' : (_this, p0) => _this.getItem(p0),
    'org.w3c.dom.setItem_$external_fun' : (_this, p0, p1) => _this.setItem(p0, p1),
    'org.w3c.dom.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.type_$external_prop_setter' : (_this, v) => _this.type = v,
    'org.w3c.dom.value_$external_prop_getter' : (_this) => _this.value,
    'org.w3c.dom.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'org.w3c.dom.HTMLInputElement_$external_class_instanceof' : (x) => x instanceof HTMLInputElement,
    'org.w3c.dom.HTMLInputElement_$external_class_get' : () => HTMLInputElement,
    'org.w3c.dom.touches_$external_prop_getter' : (_this) => _this.touches,
    'org.w3c.dom.changedTouches_$external_prop_getter' : (_this) => _this.changedTouches,
    'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
    'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
    'org.w3c.fetch.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
    'org.w3c.fetch.statusText_$external_prop_getter' : (_this) => _this.statusText,
    'org.w3c.fetch.headers_$external_prop_getter' : (_this) => _this.headers,
    'org.w3c.fetch.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.fetch.arrayBuffer_$external_fun' : (_this, ) => _this.arrayBuffer(),
    'org.w3c.fetch.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.w3c.fetch.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.files.Blob_$external_fun' : (p0, p1, isDefault0, isDefault1) => new Blob(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'kotlinx.browser.localStorage_$external_prop_getter' : () => localStorage,
    'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'kotlinx.coroutines.internal.throwAsyncJsError' : (message, className, stack) => { 
            var error = new Error();
            error.message = message;
            error.name = className;
            error.stack = stack;
            if (typeof globalThis.reportError === 'function') {
                // Up-to-date browsers and some non-browser JS runtimes (Deno, Bun)
                globalThis.reportError(error);
            } else {
                // Fallback for old browsers (pre-2022), Node.js
                setTimeout(function () { throw error }, 0);
            }
         },
    'com.awakekt.awake.core.io.jsIndexedDbRead' : 
    (namespace, path) => new Promise((resolve, reject) => {
      if (!globalThis.indexedDB) { resolve(null); return; }
      const request = indexedDB.open('awake-core-io-v2', 1);
      request.onerror = () => reject(request.error);
      request.onsuccess = () => {
        const db = request.result;
        const result = db.transaction('content', 'readonly').objectStore('content').get(namespace + ':' + path);
        result.onerror = () => reject(result.error);
        result.onsuccess = () => resolve(result.result ?? null);
      };
    })
    ,
    'com.awakekt.awake.core.io.jsIndexedDbPut' : 
    (namespace, path, kind, sizeBytes, modifiedAtEpochMs, content) => new Promise((resolve, reject) => {
      if (!globalThis.indexedDB) { resolve(null); return; }
      const request = indexedDB.open('awake-core-io-v2', 1);
      request.onerror = () => reject(request.error);
      request.onsuccess = () => {
        const db = request.result;
        const tx = db.transaction(['metadata', 'content'], 'readwrite');
        const key = namespace + ':' + path;
        tx.objectStore('metadata').put({namespace, path, kind, sizeBytes, modifiedAtEpochMs}, key);
        if (content == null) tx.objectStore('content').delete(key); else tx.objectStore('content').put(content, key);
        tx.oncomplete = () => resolve(null);
        tx.onerror = () => reject(tx.error);
      };
    })
    ,
    'com.awakekt.awake.core.io.jsIndexedDbDelete' : 
    (namespace, path) => new Promise((resolve, reject) => {
      if (!globalThis.indexedDB) { resolve(null); return; }
      const request = indexedDB.open('awake-core-io-v2', 1);
      request.onerror = () => reject(request.error);
      request.onsuccess = () => {
        const db = request.result;
        const tx = db.transaction(['metadata', 'content'], 'readwrite');
        const key = namespace + ':' + path;
        tx.objectStore('metadata').delete(key); tx.objectStore('content').delete(key);
        tx.oncomplete = () => resolve(null);
        tx.onerror = () => reject(tx.error);
      };
    })
    ,
    'com.awakekt.awake.core.io.jsIndexedDbList' : 
    (namespace) => new Promise((resolve, reject) => {
      if (!globalThis.indexedDB) { resolve('[]'); return; }
      const request = indexedDB.open('awake-core-io-v2', 1);
      request.onupgradeneeded = () => {
        const db = request.result;
        if (!db.objectStoreNames.contains('metadata')) db.createObjectStore('metadata');
        if (!db.objectStoreNames.contains('content')) db.createObjectStore('content');
      };
      request.onerror = () => reject(request.error);
      request.onsuccess = () => {
        const db = request.result;
        const cursor = db.transaction('metadata', 'readonly').objectStore('metadata').openCursor();
        const records = [];
        cursor.onerror = () => reject(cursor.error);
        cursor.onsuccess = () => {
          const item = cursor.result;
          if (item) {
            if (item.value.namespace === namespace) records.push(item.value);
            item.continue();
          } else {
            const metadata = records.map(({path, kind, sizeBytes, modifiedAtEpochMs}) => ({path, kind, sizeBytes, modifiedAtEpochMs}));
            // Kotlin Long reaches JavaScript as BigInt. Decimal strings preserve its full range for the Long serializer.
            resolve(JSON.stringify(metadata, (_, value) => typeof value === 'bigint' ? value.toString() : value));
          }
        };
      };
    })
    ,
    'com.awakekt.awake.core.io.jsStorageGet' : (key) => globalThis.localStorage ? globalThis.localStorage.getItem(key) : null,
    'com.awakekt.awake.core.io.jsStorageSet' : (key, value) => { if (globalThis.localStorage) globalThis.localStorage.setItem(key, value); },
    'com.awakekt.awake.core.localization.navigatorLanguage' : () => (typeof navigator !== 'undefined' && navigator.language) || null,
    'com.awakekt.awake.editor.core.files.jsIsDirectoryPickerSupported' : () => typeof window !== 'undefined' && typeof window.showDirectoryPicker === 'function',
    'com.awakekt.awake.editor.core.files.jsIsFilePickerSupported' : () => typeof window !== 'undefined' && (typeof window.showOpenFilePicker === 'function' || typeof document !== 'undefined'),
    'com.awakekt.awake.editor.core.files.jsShowDirectoryPicker' : 
    () => {
      if (typeof window === 'undefined' || !window.showDirectoryPicker) {
        return Promise.reject(new Error('showDirectoryPicker is not supported'));
      }
      return window.showDirectoryPicker({ id: 'awake-project', mode: 'readwrite' });
    }
    ,
    'com.awakekt.awake.editor.core.files.jsGetHandleName' : (handle) => handle ? handle.name : null,
    'com.awakekt.awake.editor.core.files.jsShowOpenFile' : 
    (extensionsCsv) => new Promise((resolve, reject) => {
      if (typeof window !== 'undefined' && typeof window.showOpenFilePicker === 'function') {
        const extList = extensionsCsv ? extensionsCsv.split(',').filter(x => x.length > 0) : [];
        const types = extList.length > 0 ? [{
          description: 'Supported Files',
          accept: { '*/*': extList.map(e => '.' + e.replace(/^\./, '')) }
        }] : [];
        window.showOpenFilePicker({ types: types, multiple: false }).then(handles => {
          if (handles && handles.length > 0) {
            handles[0].getFile().then(file => resolve(file)).catch(reject);
          } else {
            resolve(null);
          }
        }).catch(err => {
          if (err && err.name === 'AbortError') resolve(null);
          else reject(err);
        });
        return;
      }
      if (typeof document !== 'undefined') {
        const input = document.createElement('input');
        input.type = 'file';
        if (extensionsCsv) {
          input.accept = extensionsCsv.split(',').map(e => '.' + e.replace(/^\./, '')).join(',');
        }
        input.onchange = () => {
          if (input.files && input.files.length > 0) {
            resolve(input.files[0]);
          } else {
            resolve(null);
          }
        };
        input.oncancel = () => resolve(null);
        input.click();
        return;
      }
      resolve(null);
    })
    ,
    'com.awakekt.awake.editor.core.files.jsGetFileText' : (file) => file ? file.text() : Promise.resolve(''),
    'com.awakekt.awake.project.jsContentCacheGet' : 
    (db, namespace, key) => new Promise((resolve, reject) => {
      let tx;
      try { tx = db.transaction('files', 'readonly'); } catch (e) { reject(e); return; }
      tx.onerror = () => resolve(null);
      tx.onabort = () => resolve(null);
      try {
        const result = tx.objectStore('files').get([namespace, key]);
        result.onsuccess = () => resolve(result.result ?? null);
      } catch (e) { resolve(null); }
    })
        ,
    'com.awakekt.awake.project.jsContentCachePut' : 
    (db, namespace, key, content) => new Promise((resolve, reject) => {
      let tx;
      try { tx = db.transaction('files', 'readwrite'); } catch (e) { reject(e); return; }
      tx.oncomplete = () => resolve(null);
      tx.onerror = () => resolve(null);
      tx.onabort = () => resolve(null);
      try { tx.objectStore('files').put(content, [namespace, key]); } catch (e) { resolve(null); }
    })
        ,
    'com.awakekt.awake.project.jsContentCacheRetain' : 
    (db, namespace, keep) => new Promise((resolve, reject) => {
      let tx;
      try { tx = db.transaction('files', 'readwrite'); } catch (e) { reject(e); return; }
      const kept = new Set(keep);
      let deleted = 0;
      tx.oncomplete = () => resolve(deleted);
      tx.onerror = () => resolve(null);
      tx.onabort = () => resolve(null);
      try {
        const store = tx.objectStore('files');
        const cursor = store.openKeyCursor(IDBKeyRange.bound([namespace], [namespace, []]));
        cursor.onsuccess = () => {
          const item = cursor.result;
          if (!item) return;
          if (!kept.has(item.key[1])) { store.delete(item.primaryKey); deleted++; }
          item.continue();
        };
      } catch (e) { resolve(null); }
    })
        ,
    'com.awakekt.awake.project.jsContentCacheOpen' : 
    (name) => new Promise((resolve, reject) => {
      if (!globalThis.indexedDB) { resolve(null); return; }
      const request = indexedDB.open(name, 1);
      request.onupgradeneeded = () => {
        if (!request.result.objectStoreNames.contains('files')) request.result.createObjectStore('files');
      };
      request.onerror = () => reject(request.error);
      request.onsuccess = () => {
        const db = request.result;
        db.onversionchange = () => db.close();
        resolve(db);
      };
    })
        ,
    'com.awakekt.awake.project.jsContentCacheClose' : (db) => { try { db.close(); } catch (e) {} },
    'js.array.get_$external_fun' : (_this, i) => _this[i],
    'js.array.set_$external_fun' : (_this, i, value) => _this[i] = value,
    'js.buffer.ArrayBuffer_$external_fun' : (p0, p1, isDefault0) => new ArrayBuffer(p0, isDefault0 ? undefined : p1, ),
    'js.buffer.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'js.collections.JsMap_$external_fun' : (p0, isDefault0) => new Map(isDefault0 ? undefined : p0, ),
    'js.collections.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'js.collections.has_$external_fun' : (_this, p0) => _this.has(p0),
    'js.promise.then_$external_fun' : (_this, p0, p1) => _this.then(p0, p1),
    'js.typedarrays.Float32Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Float32Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'js.typedarrays.Int32Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Int32Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'js.typedarrays.Int8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'js.typedarrays.length_$external_prop_getter' : (_this) => _this.length,
    'web.gpu.getPreferredCanvasFormat_$external_fun' : (_this, ) => _this.getPreferredCanvasFormat(),
    'web.navigator.gpu_$external_prop_getter' : (_this) => _this.gpu,
    'web.gpu.Companion_$external_object_getInstance' : () => GPUCanvasContext,
    'web.gpu.GPUCanvasContext_$external_class_instanceof' : (x) => x instanceof GPUCanvasContext,
    'web.gpu.GPUCanvasContext_$external_class_get' : () => GPUCanvasContext,
    'web.html.height_$external_prop_getter' : (_this) => _this.height,
    'web.html.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'web.html.width_$external_prop_getter' : (_this) => _this.width,
    'web.html.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'web.html.getContext_$external_fun' : (_this, p0, p1, isDefault0) => _this.getContext(p0, isDefault0 ? undefined : p1, ),
    'web.navigator.navigator_$external_prop_getter' : () => navigator,
    'com.awakekt.awake.engine.window.reportBrowserFrameFailure' : (message) => console.error(message),
    'com.awakekt.awake.engine.window.reportBrowserStartupFailure' : (message) => console.error(message),
    'com.awakekt.awake.engine.window.safeAreaOf' : (canvas) => {
        let probe = document.getElementById('awake-safe-area-probe');
        if (!probe) {
            probe = document.createElement('div');
            probe.id = 'awake-safe-area-probe';
            probe.style.cssText = 'position:fixed;left:0;top:0;width:0;height:0;visibility:hidden;pointer-events:none;' +
                'padding:env(safe-area-inset-top,0px) env(safe-area-inset-right,0px) env(safe-area-inset-bottom,0px) env(safe-area-inset-left,0px)';
            document.body.appendChild(probe);
        }
        const style = getComputedStyle(probe);
        const box = canvas.getBoundingClientRect();
        const left = parseFloat(style.paddingLeft) - box.left;
        const top = parseFloat(style.paddingTop) - box.top;
        const right = parseFloat(style.paddingRight) - (window.innerWidth - box.right);
        const bottom = parseFloat(style.paddingBottom) - (window.innerHeight - box.bottom);
        return [left, top, right, bottom].join(',');
    },
    'com.awakekt.awake.engine.window.compositionData' : (event) => typeof event.data === 'string' ? event.data : null,
    'com.awakekt.awake.engine.window.pastedText' : (event) => event.clipboardData ? event.clipboardData.getData('text/plain') : null,
    'com.awakekt.awake.engine.window.writeClipboardText' : (text) => { if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).catch((e) => console.warn('Awake: clipboard write failed', e)); },
    'com.awakekt.awake.engine.window.focusWithoutScrolling' : (element) => element.focus({ preventScroll: true }),
    'com.awakekt.awake.engine.window.isComposing' : (event) => event.isComposing === true || event.keyCode === 229,
    'com.awakekt.awake.engine.window.browserGamepadButtons' : () => {
        const pads = navigator.getGamepads ? navigator.getGamepads() : [];
        for (const pad of pads) {
            if (!pad || !pad.connected || pad.mapping !== "standard") continue;
            let bits = 0;
            for (let i = 0; i < pad.buttons.length && i < 31; i++) if (pad.buttons[i].pressed) bits |= 1 << i;
            return bits;
        }
        return -1;
    },
    'com.awakekt.awake.engine.window.gestureClientX' : (event) => typeof event.clientX === 'number' ? event.clientX : NaN,
    'com.awakekt.awake.engine.window.gestureClientY' : (event) => typeof event.clientY === 'number' ? event.clientY : NaN,
    'com.awakekt.awake.engine.window.gestureScale' : (event) => typeof event.scale === 'number' ? event.scale : NaN,
    'com.awakekt.awake.engine.window.addNonPassiveListener' : (type, listener) => window.addEventListener(type, listener, { passive: false }),
    'io.ygdrasil.webgpu.toULong' : (ref) => BigInt(ref),
    'io.ygdrasil.webgpu.requestAdapter_$external_fun' : (_this, ) => _this.requestAdapter(),
    'io.ygdrasil.webgpu.requestAdapter_$external_fun_1' : (_this, p0) => _this.requestAdapter(p0),
    'io.ygdrasil.webgpu.gpu_$external_prop_getter' : (_this) => _this.gpu,
    'io.ygdrasil.webgpu.navigator_$external_object_getInstance' : () => navigator,
    'io.ygdrasil.webgpu.createJsObject' : () => ({ }),
    'io.ygdrasil.webgpu.canvas_$external_prop_getter' : (_this) => _this.canvas,
    'io.ygdrasil.webgpu.configure_$external_fun' : (_this, p0) => _this.configure(p0),
    'io.ygdrasil.webgpu.getCurrentTexture_$external_fun' : (_this, ) => _this.getCurrentTexture(),
    'io.ygdrasil.webgpu.setViewport_$external_fun' : (_this, p0, p1, p2, p3, p4, p5) => _this.setViewport(p0, p1, p2, p3, p4, p5),
    'io.ygdrasil.webgpu.setScissorRect_$external_fun' : (_this, p0, p1, p2, p3) => _this.setScissorRect(p0, p1, p2, p3),
    'io.ygdrasil.webgpu.end_$external_fun' : (_this, ) => _this.end(),
    'io.ygdrasil.webgpu.submit_$external_fun' : (_this, p0) => _this.submit(p0),
    'io.ygdrasil.webgpu.writeBuffer_$external_fun' : (_this, p0, p1, p2, p3) => _this.writeBuffer(p0, p1, p2, p3),
    'io.ygdrasil.webgpu.writeBuffer_$external_fun_1' : (_this, p0, p1, p2, p3, p4) => _this.writeBuffer(p0, p1, p2, p3, p4),
    'io.ygdrasil.webgpu.writeTexture_$external_fun' : (_this, p0, p1, p2, p3) => _this.writeTexture(p0, p1, p2, p3),
    'io.ygdrasil.webgpu.mapAsync_$external_fun' : (_this, p0, p1) => _this.mapAsync(p0, p1),
    'io.ygdrasil.webgpu.mapAsync_$external_fun_1' : (_this, p0, p1, p2) => _this.mapAsync(p0, p1, p2),
    'io.ygdrasil.webgpu.getMappedRange_$external_fun' : (_this, p0) => _this.getMappedRange(p0),
    'io.ygdrasil.webgpu.getMappedRange_$external_fun_1' : (_this, p0, p1) => _this.getMappedRange(p0, p1),
    'io.ygdrasil.webgpu.unmap_$external_fun' : (_this, ) => _this.unmap(),
    'io.ygdrasil.webgpu.destroy_$external_fun' : (_this, ) => _this.destroy(),
    'io.ygdrasil.webgpu.message_$external_prop_getter' : (_this) => _this.message,
    'io.ygdrasil.webgpu.features_$external_prop_getter' : (_this) => _this.features,
    'io.ygdrasil.webgpu.limits_$external_prop_getter' : (_this) => _this.limits,
    'io.ygdrasil.webgpu.queue_$external_prop_getter' : (_this) => _this.queue,
    'io.ygdrasil.webgpu.destroy_$external_fun_1' : (_this, ) => _this.destroy(),
    'io.ygdrasil.webgpu.createBuffer_$external_fun' : (_this, p0) => _this.createBuffer(p0),
    'io.ygdrasil.webgpu.createTexture_$external_fun' : (_this, p0) => _this.createTexture(p0),
    'io.ygdrasil.webgpu.createSampler_$external_fun' : (_this, ) => _this.createSampler(),
    'io.ygdrasil.webgpu.createSampler_$external_fun_1' : (_this, p0) => _this.createSampler(p0),
    'io.ygdrasil.webgpu.createBindGroupLayout_$external_fun' : (_this, p0) => _this.createBindGroupLayout(p0),
    'io.ygdrasil.webgpu.createPipelineLayout_$external_fun' : (_this, p0) => _this.createPipelineLayout(p0),
    'io.ygdrasil.webgpu.createBindGroup_$external_fun' : (_this, p0) => _this.createBindGroup(p0),
    'io.ygdrasil.webgpu.createShaderModule_$external_fun' : (_this, p0) => _this.createShaderModule(p0),
    'io.ygdrasil.webgpu.createRenderPipeline_$external_fun' : (_this, p0) => _this.createRenderPipeline(p0),
    'io.ygdrasil.webgpu.createCommandEncoder_$external_fun' : (_this, ) => _this.createCommandEncoder(),
    'io.ygdrasil.webgpu.createCommandEncoder_$external_fun_1' : (_this, p0) => _this.createCommandEncoder(p0),
    'io.ygdrasil.webgpu.createQuerySet_$external_fun' : (_this, p0) => _this.createQuerySet(p0),
    'io.ygdrasil.webgpu.features_$external_prop_getter_1' : (_this) => _this.features,
    'io.ygdrasil.webgpu.limits_$external_prop_getter_1' : (_this) => _this.limits,
    'io.ygdrasil.webgpu.requestDevice_$external_fun' : (_this, ) => _this.requestDevice(),
    'io.ygdrasil.webgpu.requestDevice_$external_fun_1' : (_this, p0) => _this.requestDevice(p0),
    'io.ygdrasil.webgpu.maxTextureDimension1D_$external_prop_getter' : (_this) => _this.maxTextureDimension1D,
    'io.ygdrasil.webgpu.maxTextureDimension2D_$external_prop_getter' : (_this) => _this.maxTextureDimension2D,
    'io.ygdrasil.webgpu.maxTextureDimension3D_$external_prop_getter' : (_this) => _this.maxTextureDimension3D,
    'io.ygdrasil.webgpu.maxTextureArrayLayers_$external_prop_getter' : (_this) => _this.maxTextureArrayLayers,
    'io.ygdrasil.webgpu.maxBindGroups_$external_prop_getter' : (_this) => _this.maxBindGroups,
    'io.ygdrasil.webgpu.maxBindGroupsPlusVertexBuffers_$external_prop_getter' : (_this) => _this.maxBindGroupsPlusVertexBuffers,
    'io.ygdrasil.webgpu.maxBindingsPerBindGroup_$external_prop_getter' : (_this) => _this.maxBindingsPerBindGroup,
    'io.ygdrasil.webgpu.maxDynamicUniformBuffersPerPipelineLayout_$external_prop_getter' : (_this) => _this.maxDynamicUniformBuffersPerPipelineLayout,
    'io.ygdrasil.webgpu.maxDynamicStorageBuffersPerPipelineLayout_$external_prop_getter' : (_this) => _this.maxDynamicStorageBuffersPerPipelineLayout,
    'io.ygdrasil.webgpu.maxSampledTexturesPerShaderStage_$external_prop_getter' : (_this) => _this.maxSampledTexturesPerShaderStage,
    'io.ygdrasil.webgpu.maxSamplersPerShaderStage_$external_prop_getter' : (_this) => _this.maxSamplersPerShaderStage,
    'io.ygdrasil.webgpu.maxStorageBuffersPerShaderStage_$external_prop_getter' : (_this) => _this.maxStorageBuffersPerShaderStage,
    'io.ygdrasil.webgpu.maxStorageTexturesPerShaderStage_$external_prop_getter' : (_this) => _this.maxStorageTexturesPerShaderStage,
    'io.ygdrasil.webgpu.maxUniformBuffersPerShaderStage_$external_prop_getter' : (_this) => _this.maxUniformBuffersPerShaderStage,
    'io.ygdrasil.webgpu.maxUniformBufferBindingSize_$external_prop_getter' : (_this) => _this.maxUniformBufferBindingSize,
    'io.ygdrasil.webgpu.maxStorageBufferBindingSize_$external_prop_getter' : (_this) => _this.maxStorageBufferBindingSize,
    'io.ygdrasil.webgpu.minUniformBufferOffsetAlignment_$external_prop_getter' : (_this) => _this.minUniformBufferOffsetAlignment,
    'io.ygdrasil.webgpu.minStorageBufferOffsetAlignment_$external_prop_getter' : (_this) => _this.minStorageBufferOffsetAlignment,
    'io.ygdrasil.webgpu.maxVertexBuffers_$external_prop_getter' : (_this) => _this.maxVertexBuffers,
    'io.ygdrasil.webgpu.maxBufferSize_$external_prop_getter' : (_this) => _this.maxBufferSize,
    'io.ygdrasil.webgpu.maxVertexAttributes_$external_prop_getter' : (_this) => _this.maxVertexAttributes,
    'io.ygdrasil.webgpu.maxVertexBufferArrayStride_$external_prop_getter' : (_this) => _this.maxVertexBufferArrayStride,
    'io.ygdrasil.webgpu.maxInterStageShaderVariables_$external_prop_getter' : (_this) => _this.maxInterStageShaderVariables,
    'io.ygdrasil.webgpu.maxColorAttachments_$external_prop_getter' : (_this) => _this.maxColorAttachments,
    'io.ygdrasil.webgpu.maxColorAttachmentBytesPerSample_$external_prop_getter' : (_this) => _this.maxColorAttachmentBytesPerSample,
    'io.ygdrasil.webgpu.maxComputeWorkgroupStorageSize_$external_prop_getter' : (_this) => _this.maxComputeWorkgroupStorageSize,
    'io.ygdrasil.webgpu.maxComputeInvocationsPerWorkgroup_$external_prop_getter' : (_this) => _this.maxComputeInvocationsPerWorkgroup,
    'io.ygdrasil.webgpu.maxComputeWorkgroupSizeX_$external_prop_getter' : (_this) => _this.maxComputeWorkgroupSizeX,
    'io.ygdrasil.webgpu.maxComputeWorkgroupSizeY_$external_prop_getter' : (_this) => _this.maxComputeWorkgroupSizeY,
    'io.ygdrasil.webgpu.maxComputeWorkgroupSizeZ_$external_prop_getter' : (_this) => _this.maxComputeWorkgroupSizeZ,
    'io.ygdrasil.webgpu.maxComputeWorkgroupsPerDimension_$external_prop_getter' : (_this) => _this.maxComputeWorkgroupsPerDimension,
    'io.ygdrasil.webgpu.requiredFeatures_$external_prop_setter' : (_this, v) => _this.requiredFeatures = v,
    'io.ygdrasil.webgpu.requiredLimits_$external_prop_setter' : (_this, v) => _this.requiredLimits = v,
    'io.ygdrasil.webgpu.defaultQueue_$external_prop_setter' : (_this, v) => _this.defaultQueue = v,
    'io.ygdrasil.webgpu.featureLevel_$external_prop_setter' : (_this, v) => _this.featureLevel = v,
    'io.ygdrasil.webgpu.powerPreference_$external_prop_setter' : (_this, v) => _this.powerPreference = v,
    'io.ygdrasil.webgpu.forceFallbackAdapter_$external_prop_setter' : (_this, v) => _this.forceFallbackAdapter = v,
    'io.ygdrasil.webgpu.xrCompatible_$external_prop_setter' : (_this, v) => _this.xrCompatible = v,
    'io.ygdrasil.webgpu.r_$external_prop_setter' : (_this, v) => _this.r = v,
    'io.ygdrasil.webgpu.g_$external_prop_setter' : (_this, v) => _this.g = v,
    'io.ygdrasil.webgpu.b_$external_prop_setter' : (_this, v) => _this.b = v,
    'io.ygdrasil.webgpu.a_$external_prop_setter' : (_this, v) => _this.a = v,
    'io.ygdrasil.webgpu.texture_$external_prop_setter' : (_this, v) => _this.texture = v,
    'io.ygdrasil.webgpu.mipLevel_$external_prop_setter' : (_this, v) => _this.mipLevel = v,
    'io.ygdrasil.webgpu.origin_$external_prop_setter' : (_this, v) => _this.origin = v,
    'io.ygdrasil.webgpu.aspect_$external_prop_setter' : (_this, v) => _this.aspect = v,
    'io.ygdrasil.webgpu.offset_$external_prop_setter' : (_this, v) => _this.offset = v,
    'io.ygdrasil.webgpu.bytesPerRow_$external_prop_setter' : (_this, v) => _this.bytesPerRow = v,
    'io.ygdrasil.webgpu.rowsPerImage_$external_prop_setter' : (_this, v) => _this.rowsPerImage = v,
    'io.ygdrasil.webgpu.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'io.ygdrasil.webgpu.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'io.ygdrasil.webgpu.depthOrArrayLayers_$external_prop_setter' : (_this, v) => _this.depthOrArrayLayers = v,
    'io.ygdrasil.webgpu.beginRenderPass_$external_fun' : (_this, p0) => _this.beginRenderPass(p0),
    'io.ygdrasil.webgpu.copyBufferToBuffer_$external_fun' : (_this, p0, p1, p2, p3) => _this.copyBufferToBuffer(p0, p1, p2, p3),
    'io.ygdrasil.webgpu.copyBufferToBuffer_$external_fun_1' : (_this, p0, p1, p2, p3, p4) => _this.copyBufferToBuffer(p0, p1, p2, p3, p4),
    'io.ygdrasil.webgpu.copyTextureToBuffer_$external_fun' : (_this, p0, p1, p2) => _this.copyTextureToBuffer(p0, p1, p2),
    'io.ygdrasil.webgpu.copyTextureToTexture_$external_fun' : (_this, p0, p1, p2) => _this.copyTextureToTexture(p0, p1, p2),
    'io.ygdrasil.webgpu.resolveQuerySet_$external_fun' : (_this, p0, p1, p2, p3, p4) => _this.resolveQuerySet(p0, p1, p2, p3, p4),
    'io.ygdrasil.webgpu.finish_$external_fun' : (_this, ) => _this.finish(),
    'io.ygdrasil.webgpu.finish_$external_fun_1' : (_this, p0) => _this.finish(p0),
    'io.ygdrasil.webgpu.code_$external_prop_setter' : (_this, v) => _this.code = v,
    'io.ygdrasil.webgpu.compilationHints_$external_prop_setter' : (_this, v) => _this.compilationHints = v,
    'io.ygdrasil.webgpu.bindGroupLayouts_$external_prop_setter' : (_this, v) => _this.bindGroupLayouts = v,
    'io.ygdrasil.webgpu.vertex_$external_prop_setter' : (_this, v) => _this.vertex = v,
    'io.ygdrasil.webgpu.primitive_$external_prop_setter' : (_this, v) => _this.primitive = v,
    'io.ygdrasil.webgpu.depthStencil_$external_prop_setter' : (_this, v) => _this.depthStencil = v,
    'io.ygdrasil.webgpu.multisample_$external_prop_setter' : (_this, v) => _this.multisample = v,
    'io.ygdrasil.webgpu.fragment_$external_prop_setter' : (_this, v) => _this.fragment = v,
    'io.ygdrasil.webgpu.size_$external_prop_setter' : (_this, v) => _this.size = v,
    'io.ygdrasil.webgpu.usage_$external_prop_setter' : (_this, v) => _this.usage = v,
    'io.ygdrasil.webgpu.mappedAtCreation_$external_prop_setter' : (_this, v) => _this.mappedAtCreation = v,
    'io.ygdrasil.webgpu.createView_$external_fun' : (_this, ) => _this.createView(),
    'io.ygdrasil.webgpu.createView_$external_fun_1' : (_this, p0) => _this.createView(p0),
    'io.ygdrasil.webgpu.destroy_$external_fun_2' : (_this, ) => _this.destroy(),
    'io.ygdrasil.webgpu.size_$external_prop_setter_1' : (_this, v) => _this.size = v,
    'io.ygdrasil.webgpu.mipLevelCount_$external_prop_setter' : (_this, v) => _this.mipLevelCount = v,
    'io.ygdrasil.webgpu.sampleCount_$external_prop_setter' : (_this, v) => _this.sampleCount = v,
    'io.ygdrasil.webgpu.dimension_$external_prop_setter' : (_this, v) => _this.dimension = v,
    'io.ygdrasil.webgpu.format_$external_prop_setter' : (_this, v) => _this.format = v,
    'io.ygdrasil.webgpu.usage_$external_prop_setter_1' : (_this, v) => _this.usage = v,
    'io.ygdrasil.webgpu.viewFormats_$external_prop_setter' : (_this, v) => _this.viewFormats = v,
    'io.ygdrasil.webgpu.layout_$external_prop_setter' : (_this, v) => _this.layout = v,
    'io.ygdrasil.webgpu.entries_$external_prop_setter' : (_this, v) => _this.entries = v,
    'io.ygdrasil.webgpu.addressModeU_$external_prop_setter' : (_this, v) => _this.addressModeU = v,
    'io.ygdrasil.webgpu.addressModeV_$external_prop_setter' : (_this, v) => _this.addressModeV = v,
    'io.ygdrasil.webgpu.addressModeW_$external_prop_setter' : (_this, v) => _this.addressModeW = v,
    'io.ygdrasil.webgpu.magFilter_$external_prop_setter' : (_this, v) => _this.magFilter = v,
    'io.ygdrasil.webgpu.minFilter_$external_prop_setter' : (_this, v) => _this.minFilter = v,
    'io.ygdrasil.webgpu.mipmapFilter_$external_prop_setter' : (_this, v) => _this.mipmapFilter = v,
    'io.ygdrasil.webgpu.lodMinClamp_$external_prop_setter' : (_this, v) => _this.lodMinClamp = v,
    'io.ygdrasil.webgpu.lodMaxClamp_$external_prop_setter' : (_this, v) => _this.lodMaxClamp = v,
    'io.ygdrasil.webgpu.compare_$external_prop_setter' : (_this, v) => _this.compare = v,
    'io.ygdrasil.webgpu.maxAnisotropy_$external_prop_setter' : (_this, v) => _this.maxAnisotropy = v,
    'io.ygdrasil.webgpu.entries_$external_prop_setter_1' : (_this, v) => _this.entries = v,
    'io.ygdrasil.webgpu.destroy_$external_fun_3' : (_this, ) => _this.destroy(),
    'io.ygdrasil.webgpu.type_$external_prop_setter' : (_this, v) => _this.type = v,
    'io.ygdrasil.webgpu.count_$external_prop_setter' : (_this, v) => _this.count = v,
    'io.ygdrasil.webgpu.x_$external_prop_setter' : (_this, v) => _this.x = v,
    'io.ygdrasil.webgpu.y_$external_prop_setter' : (_this, v) => _this.y = v,
    'io.ygdrasil.webgpu.z_$external_prop_setter' : (_this, v) => _this.z = v,
    'io.ygdrasil.webgpu.colorAttachments_$external_prop_setter' : (_this, v) => _this.colorAttachments = v,
    'io.ygdrasil.webgpu.depthStencilAttachment_$external_prop_setter' : (_this, v) => _this.depthStencilAttachment = v,
    'io.ygdrasil.webgpu.maxDrawCount_$external_prop_setter' : (_this, v) => _this.maxDrawCount = v,
    'io.ygdrasil.webgpu.buffer_$external_prop_setter' : (_this, v) => _this.buffer = v,
    'io.ygdrasil.webgpu.entryPoint_$external_prop_setter' : (_this, v) => _this.entryPoint = v,
    'io.ygdrasil.webgpu.layout_$external_prop_setter_1' : (_this, v) => _this.layout = v,
    'io.ygdrasil.webgpu.buffers_$external_prop_setter' : (_this, v) => _this.buffers = v,
    'io.ygdrasil.webgpu.topology_$external_prop_setter' : (_this, v) => _this.topology = v,
    'io.ygdrasil.webgpu.stripIndexFormat_$external_prop_setter' : (_this, v) => _this.stripIndexFormat = v,
    'io.ygdrasil.webgpu.frontFace_$external_prop_setter' : (_this, v) => _this.frontFace = v,
    'io.ygdrasil.webgpu.cullMode_$external_prop_setter' : (_this, v) => _this.cullMode = v,
    'io.ygdrasil.webgpu.unclippedDepth_$external_prop_setter' : (_this, v) => _this.unclippedDepth = v,
    'io.ygdrasil.webgpu.format_$external_prop_setter_1' : (_this, v) => _this.format = v,
    'io.ygdrasil.webgpu.depthWriteEnabled_$external_prop_setter' : (_this, v) => _this.depthWriteEnabled = v,
    'io.ygdrasil.webgpu.depthCompare_$external_prop_setter' : (_this, v) => _this.depthCompare = v,
    'io.ygdrasil.webgpu.stencilFront_$external_prop_setter' : (_this, v) => _this.stencilFront = v,
    'io.ygdrasil.webgpu.stencilBack_$external_prop_setter' : (_this, v) => _this.stencilBack = v,
    'io.ygdrasil.webgpu.stencilReadMask_$external_prop_setter' : (_this, v) => _this.stencilReadMask = v,
    'io.ygdrasil.webgpu.stencilWriteMask_$external_prop_setter' : (_this, v) => _this.stencilWriteMask = v,
    'io.ygdrasil.webgpu.depthBias_$external_prop_setter' : (_this, v) => _this.depthBias = v,
    'io.ygdrasil.webgpu.depthBiasSlopeScale_$external_prop_setter' : (_this, v) => _this.depthBiasSlopeScale = v,
    'io.ygdrasil.webgpu.depthBiasClamp_$external_prop_setter' : (_this, v) => _this.depthBiasClamp = v,
    'io.ygdrasil.webgpu.targets_$external_prop_setter' : (_this, v) => _this.targets = v,
    'io.ygdrasil.webgpu.count_$external_prop_setter_1' : (_this, v) => _this.count = v,
    'io.ygdrasil.webgpu.mask_$external_prop_setter' : (_this, v) => _this.mask = v,
    'io.ygdrasil.webgpu.alphaToCoverageEnabled_$external_prop_setter' : (_this, v) => _this.alphaToCoverageEnabled = v,
    'io.ygdrasil.webgpu.arrayStride_$external_prop_setter' : (_this, v) => _this.arrayStride = v,
    'io.ygdrasil.webgpu.stepMode_$external_prop_setter' : (_this, v) => _this.stepMode = v,
    'io.ygdrasil.webgpu.attributes_$external_prop_setter' : (_this, v) => _this.attributes = v,
    'io.ygdrasil.webgpu.compare_$external_prop_setter_1' : (_this, v) => _this.compare = v,
    'io.ygdrasil.webgpu.failOp_$external_prop_setter' : (_this, v) => _this.failOp = v,
    'io.ygdrasil.webgpu.depthFailOp_$external_prop_setter' : (_this, v) => _this.depthFailOp = v,
    'io.ygdrasil.webgpu.passOp_$external_prop_setter' : (_this, v) => _this.passOp = v,
    'io.ygdrasil.webgpu.format_$external_prop_setter_2' : (_this, v) => _this.format = v,
    'io.ygdrasil.webgpu.blend_$external_prop_setter' : (_this, v) => _this.blend = v,
    'io.ygdrasil.webgpu.writeMask_$external_prop_setter' : (_this, v) => _this.writeMask = v,
    'io.ygdrasil.webgpu.format_$external_prop_setter_3' : (_this, v) => _this.format = v,
    'io.ygdrasil.webgpu.offset_$external_prop_setter_1' : (_this, v) => _this.offset = v,
    'io.ygdrasil.webgpu.shaderLocation_$external_prop_setter' : (_this, v) => _this.shaderLocation = v,
    'io.ygdrasil.webgpu.color_$external_prop_setter' : (_this, v) => _this.color = v,
    'io.ygdrasil.webgpu.alpha_$external_prop_setter' : (_this, v) => _this.alpha = v,
    'io.ygdrasil.webgpu.operation_$external_prop_setter' : (_this, v) => _this.operation = v,
    'io.ygdrasil.webgpu.srcFactor_$external_prop_setter' : (_this, v) => _this.srcFactor = v,
    'io.ygdrasil.webgpu.dstFactor_$external_prop_setter' : (_this, v) => _this.dstFactor = v,
    'io.ygdrasil.webgpu.module_$external_prop_setter' : (_this, v) => _this.module = v,
    'io.ygdrasil.webgpu.entryPoint_$external_prop_setter_1' : (_this, v) => _this.entryPoint = v,
    'io.ygdrasil.webgpu.format_$external_prop_setter_4' : (_this, v) => _this.format = v,
    'io.ygdrasil.webgpu.dimension_$external_prop_setter_1' : (_this, v) => _this.dimension = v,
    'io.ygdrasil.webgpu.aspect_$external_prop_setter_1' : (_this, v) => _this.aspect = v,
    'io.ygdrasil.webgpu.baseMipLevel_$external_prop_setter' : (_this, v) => _this.baseMipLevel = v,
    'io.ygdrasil.webgpu.mipLevelCount_$external_prop_setter_1' : (_this, v) => _this.mipLevelCount = v,
    'io.ygdrasil.webgpu.baseArrayLayer_$external_prop_setter' : (_this, v) => _this.baseArrayLayer = v,
    'io.ygdrasil.webgpu.arrayLayerCount_$external_prop_setter' : (_this, v) => _this.arrayLayerCount = v,
    'io.ygdrasil.webgpu.binding_$external_prop_setter' : (_this, v) => _this.binding = v,
    'io.ygdrasil.webgpu.resource_$external_prop_setter' : (_this, v) => _this.resource = v,
    'io.ygdrasil.webgpu.buffer_$external_prop_setter_1' : (_this, v) => _this.buffer = v,
    'io.ygdrasil.webgpu.offset_$external_prop_setter_2' : (_this, v) => _this.offset = v,
    'io.ygdrasil.webgpu.size_$external_prop_setter_2' : (_this, v) => _this.size = v,
    'io.ygdrasil.webgpu.binding_$external_prop_setter_1' : (_this, v) => _this.binding = v,
    'io.ygdrasil.webgpu.visibility_$external_prop_setter' : (_this, v) => _this.visibility = v,
    'io.ygdrasil.webgpu.buffer_$external_prop_setter_2' : (_this, v) => _this.buffer = v,
    'io.ygdrasil.webgpu.sampler_$external_prop_setter' : (_this, v) => _this.sampler = v,
    'io.ygdrasil.webgpu.texture_$external_prop_setter_1' : (_this, v) => _this.texture = v,
    'io.ygdrasil.webgpu.storageTexture_$external_prop_setter' : (_this, v) => _this.storageTexture = v,
    'io.ygdrasil.webgpu.type_$external_prop_setter_1' : (_this, v) => _this.type = v,
    'io.ygdrasil.webgpu.hasDynamicOffset_$external_prop_setter' : (_this, v) => _this.hasDynamicOffset = v,
    'io.ygdrasil.webgpu.minBindingSize_$external_prop_setter' : (_this, v) => _this.minBindingSize = v,
    'io.ygdrasil.webgpu.type_$external_prop_setter_2' : (_this, v) => _this.type = v,
    'io.ygdrasil.webgpu.sampleType_$external_prop_setter' : (_this, v) => _this.sampleType = v,
    'io.ygdrasil.webgpu.viewDimension_$external_prop_setter' : (_this, v) => _this.viewDimension = v,
    'io.ygdrasil.webgpu.multisampled_$external_prop_setter' : (_this, v) => _this.multisampled = v,
    'io.ygdrasil.webgpu.access_$external_prop_setter' : (_this, v) => _this.access = v,
    'io.ygdrasil.webgpu.format_$external_prop_setter_5' : (_this, v) => _this.format = v,
    'io.ygdrasil.webgpu.viewDimension_$external_prop_setter_1' : (_this, v) => _this.viewDimension = v,
    'io.ygdrasil.webgpu.view_$external_prop_setter' : (_this, v) => _this.view = v,
    'io.ygdrasil.webgpu.depthSlice_$external_prop_setter' : (_this, v) => _this.depthSlice = v,
    'io.ygdrasil.webgpu.resolveTarget_$external_prop_setter' : (_this, v) => _this.resolveTarget = v,
    'io.ygdrasil.webgpu.clearValue_$external_prop_setter' : (_this, v) => _this.clearValue = v,
    'io.ygdrasil.webgpu.loadOp_$external_prop_setter' : (_this, v) => _this.loadOp = v,
    'io.ygdrasil.webgpu.storeOp_$external_prop_setter' : (_this, v) => _this.storeOp = v,
    'io.ygdrasil.webgpu.view_$external_prop_setter_1' : (_this, v) => _this.view = v,
    'io.ygdrasil.webgpu.depthClearValue_$external_prop_setter' : (_this, v) => _this.depthClearValue = v,
    'io.ygdrasil.webgpu.depthLoadOp_$external_prop_setter' : (_this, v) => _this.depthLoadOp = v,
    'io.ygdrasil.webgpu.depthStoreOp_$external_prop_setter' : (_this, v) => _this.depthStoreOp = v,
    'io.ygdrasil.webgpu.depthReadOnly_$external_prop_setter' : (_this, v) => _this.depthReadOnly = v,
    'io.ygdrasil.webgpu.stencilClearValue_$external_prop_setter' : (_this, v) => _this.stencilClearValue = v,
    'io.ygdrasil.webgpu.stencilLoadOp_$external_prop_setter' : (_this, v) => _this.stencilLoadOp = v,
    'io.ygdrasil.webgpu.stencilStoreOp_$external_prop_setter' : (_this, v) => _this.stencilStoreOp = v,
    'io.ygdrasil.webgpu.stencilReadOnly_$external_prop_setter' : (_this, v) => _this.stencilReadOnly = v,
    'io.ygdrasil.webgpu.device_$external_prop_setter' : (_this, v) => _this.device = v,
    'io.ygdrasil.webgpu.format_$external_prop_setter_6' : (_this, v) => _this.format = v,
    'io.ygdrasil.webgpu.usage_$external_prop_setter_2' : (_this, v) => _this.usage = v,
    'io.ygdrasil.webgpu.viewFormats_$external_prop_setter_1' : (_this, v) => _this.viewFormats = v,
    'io.ygdrasil.webgpu.colorSpace_$external_prop_setter' : (_this, v) => _this.colorSpace = v,
    'io.ygdrasil.webgpu.toneMapping_$external_prop_setter' : (_this, v) => _this.toneMapping = v,
    'io.ygdrasil.webgpu.alphaMode_$external_prop_setter' : (_this, v) => _this.alphaMode = v,
    'io.ygdrasil.webgpu.mode_$external_prop_setter' : (_this, v) => _this.mode = v,
    'io.ygdrasil.webgpu.setBindGroup_$external_fun' : (_this, p0, p1) => _this.setBindGroup(p0, p1),
    'io.ygdrasil.webgpu.setBindGroup_$external_fun_1' : (_this, p0, p1, p2) => _this.setBindGroup(p0, p1, p2),
    'io.ygdrasil.webgpu.setPipeline_$external_fun' : (_this, p0) => _this.setPipeline(p0),
    'io.ygdrasil.webgpu.setIndexBuffer_$external_fun' : (_this, p0, p1, p2) => _this.setIndexBuffer(p0, p1, p2),
    'io.ygdrasil.webgpu.setIndexBuffer_$external_fun_1' : (_this, p0, p1, p2, p3) => _this.setIndexBuffer(p0, p1, p2, p3),
    'io.ygdrasil.webgpu.setVertexBuffer_$external_fun' : (_this, p0, p1, p2) => _this.setVertexBuffer(p0, p1, p2),
    'io.ygdrasil.webgpu.setVertexBuffer_$external_fun_1' : (_this, p0, p1, p2, p3) => _this.setVertexBuffer(p0, p1, p2, p3),
    'io.ygdrasil.webgpu.draw_$external_fun' : (_this, p0, p1, p2, p3) => _this.draw(p0, p1, p2, p3),
    'io.ygdrasil.webgpu.drawIndexed_$external_fun' : (_this, p0, p1, p2, p3, p4) => _this.drawIndexed(p0, p1, p2, p3, p4),
    'io.ygdrasil.webgpu.label_$external_prop_setter' : (_this, v) => _this.label = v,
    'io.ygdrasil.webgpu.getBindGroupLayout_$external_fun' : (_this, p0) => _this.getBindGroupLayout(p0),
    'io.ygdrasil.webgpu.layout_$external_prop_setter_2' : (_this, v) => _this.layout = v,
    'io.ygdrasil.webgpu.toJsNumber' : (x) => x,
    'io.ygdrasil.webgpu.toJsNumber_1' : (x) => x,
    'io.ygdrasil.webgpu.toJsNumber_2' : (x) => x,
    'io.ygdrasil.webgpu.addEventListener_$external_fun' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'io.ygdrasil.webgpu.error_$external_prop_getter' : (_this) => _this.error,
    'io.ygdrasil.webgpu.mapper.isGPUValidationError' : (error) => error instanceof GPUValidationError,
    'io.ygdrasil.webgpu.mapper.isGPUInternalError' : (error) => error instanceof GPUInternalError,
    'io.ygdrasil.webgpu.mapper.isGPUOutOfMemoryError' : (error) => error instanceof GPUOutOfMemoryError,
    'com.awakekt.awake.webgpu.copyOfLinearMemory' : (memory, byteOffset, byteSize) => memory.buffer.slice(byteOffset, byteOffset + byteSize),
    'com.awakekt.awake.webgpu.application.browserExposesWebGpu' : () => typeof navigator !== 'undefined' && navigator.gpu != null,
    'com.awakekt.awake.webgpu.application.reportWebGpuRuntimeFailure' : (message) => console.error(message),
    'com.awakekt.awake.webgpu.renderer.writeFromLinearMemory' : (queue, buffer, byteOffset, byteSize) => queue.writeBuffer(buffer, 0, wasmExports.memory.buffer, byteOffset, byteSize),
    'com.awakekt.awake.physics.jolt.joltCreateBody' : 
        (world, shapeKind, hx, hy, hz, radius, halfHeight, px, py, pz, qw, qx, qy, qz, motionTypeCode, isStatic, layerIndex, isSensor, plane2d) => {
            const jolt = world.jolt;
            const halfExtent = new jolt.Vec3(hx, hy, hz);
            const shape = shapeKind === 0
                ? new jolt.BoxShape(halfExtent, 0.05, null)
                : (shapeKind === 1
                    ? new jolt.SphereShape(radius, null)
                    : new jolt.CapsuleShape(halfHeight, radius, null));
            const motionType = motionTypeCode === 0
                ? jolt.EMotionType_Static
                : (motionTypeCode === 1 ? jolt.EMotionType_Kinematic : jolt.EMotionType_Dynamic);

            const position = new jolt.RVec3(px, py, pz);
            const rotation = new jolt.Quat(qx, qy, qz, qw);
            const bodyCreationSettings = new jolt.BodyCreationSettings(
                shape, position, rotation, motionType, layerIndex
            );
            bodyCreationSettings.mIsSensor = isSensor;
            bodyCreationSettings.mAllowedDOFs = plane2d ? jolt.EAllowedDOFs_Plane2D : jolt.EAllowedDOFs_All;
            const body = world.bodyInterface.CreateBody(bodyCreationSettings);
            jolt.destroy(bodyCreationSettings);
            jolt.destroy(rotation);
            jolt.destroy(position);
            jolt.destroy(halfExtent);
            const activation = isStatic ? jolt.EActivation_DontActivate : jolt.EActivation_Activate;
            world.bodyInterface.AddBody(body.GetID(), activation);
            return body.GetID().GetIndexAndSequenceNumber();
        }
        ,
    'com.awakekt.awake.physics.jolt.joltSetReporting' : 
        (world, idNum, reporting) => {
            if (reporting) world.reporting.add(idNum); else world.reporting.delete(idNum);
        }
        ,
    'com.awakekt.awake.physics.jolt.jsNewArray' : () => [],
    'com.awakekt.awake.physics.jolt.jsArrayPush' : (arr, value) => { arr.push(value); },
    'com.awakekt.awake.physics.jolt.joltCreateHullBody' : 
        (world, pts, px, py, pz, qw, qx, qy, qz, motionTypeCode, isStatic, layerIndex, isSensor, plane2d) => {
            const jolt = world.jolt;
            const points = new jolt.ArrayVec3();
            points.reserve(pts.length / 3);
            const point = world.query.vector;
            for (let i = 0; i < pts.length; i += 3) {
                point.Set(pts[i], pts[i + 1], pts[i + 2]);
                points.push_back(point);
            }
            const settings = new jolt.ConvexHullShapeSettings();
            settings.mPoints = points;
            const shapeResult = settings.Create();
            const shape = shapeResult.Get();
            const motionType = motionTypeCode === 0
                ? jolt.EMotionType_Static
                : (motionTypeCode === 1 ? jolt.EMotionType_Kinematic : jolt.EMotionType_Dynamic);
            const position = new jolt.RVec3(px, py, pz);
            const rotation = new jolt.Quat(qx, qy, qz, qw);
            const bodyCreationSettings = new jolt.BodyCreationSettings(
                shape, position, rotation, motionType, layerIndex
            );
            bodyCreationSettings.mIsSensor = isSensor;
            bodyCreationSettings.mAllowedDOFs = plane2d ? jolt.EAllowedDOFs_Plane2D : jolt.EAllowedDOFs_All;
            const body = world.bodyInterface.CreateBody(bodyCreationSettings);
            jolt.destroy(bodyCreationSettings);
            jolt.destroy(rotation);
            jolt.destroy(position);
            jolt.destroy(shapeResult);
            jolt.destroy(settings);
            jolt.destroy(points);
            const activation = isStatic ? jolt.EActivation_DontActivate : jolt.EActivation_Activate;
            world.bodyInterface.AddBody(body.GetID(), activation);
            return body.GetID().GetIndexAndSequenceNumber();
        }
        ,
    'com.awakekt.awake.physics.jolt.joltCreateMeshBody' : 
        (world, verts, indices, px, py, pz, qw, qx, qy, qz, layerIndex) => {
            const jolt = world.jolt;
            const triangles = new jolt.TriangleList();
            const count = indices.length / 3;
            triangles.resize(count);
            const corner = world.query.corner;
            const setCorner = (tri, slot, i) => {
                corner.x = verts[i];
                corner.y = verts[i + 1];
                corner.z = verts[i + 2];
                tri.set_mV(slot, corner);
            };
            for (let t = 0; t < count; t++) {
                const tri = triangles.at(t);
                setCorner(tri, 0, indices[t * 3] * 3);
                setCorner(tri, 1, indices[t * 3 + 1] * 3);
                setCorner(tri, 2, indices[t * 3 + 2] * 3);
            }
            const settings = new jolt.MeshShapeSettings(triangles);
            const shapeResult = settings.Create();
            const shape = shapeResult.Get();
            const position = new jolt.RVec3(px, py, pz);
            const rotation = new jolt.Quat(qx, qy, qz, qw);
            const bodyCreationSettings = new jolt.BodyCreationSettings(
                shape, position, rotation, jolt.EMotionType_Static, layerIndex
            );
            const body = world.bodyInterface.CreateBody(bodyCreationSettings);
            jolt.destroy(bodyCreationSettings);
            jolt.destroy(rotation);
            jolt.destroy(position);
            jolt.destroy(shapeResult);
            jolt.destroy(settings);
            jolt.destroy(triangles);
            world.bodyInterface.AddBody(body.GetID(), jolt.EActivation_DontActivate);
            return body.GetID().GetIndexAndSequenceNumber();
        }
        ,
    'com.awakekt.awake.physics.jolt.joltCreateHeightFieldBody' : 
        (world, samples, sampleCount, offsetX, offsetZ, sx, sy, sz, px, py, pz) => {
            const jolt = world.jolt;
            const heights = new jolt.ArrayFloat();
            heights.reserve(samples.length);
            for (let i = 0; i < samples.length; i++) heights.push_back(samples[i]);
            const settings = new jolt.HeightFieldShapeSettings();
            settings.mHeightSamples = heights;
            settings.mSampleCount = sampleCount;
            const offset = new jolt.Vec3(offsetX, 0, offsetZ);
            const scale = new jolt.Vec3(sx, sy, sz);
            settings.mOffset = offset;
            settings.mScale = scale;
            const shapeResult = settings.Create();
            const shape = shapeResult.Get();
            const position = new jolt.RVec3(px, py, pz);
            const rotation = new jolt.Quat(0, 0, 0, 1);
            const bodyCreationSettings = new jolt.BodyCreationSettings(
                shape, position, rotation, jolt.EMotionType_Static, 0
            );
            const body = world.bodyInterface.CreateBody(bodyCreationSettings);
            jolt.destroy(bodyCreationSettings);
            jolt.destroy(rotation);
            jolt.destroy(position);
            jolt.destroy(scale);
            jolt.destroy(offset);
            jolt.destroy(shapeResult);
            jolt.destroy(settings);
            jolt.destroy(heights);
            world.bodyInterface.AddBody(body.GetID(), jolt.EActivation_DontActivate);
            return body.GetID().GetIndexAndSequenceNumber();
        }
        ,
    'com.awakekt.awake.physics.jolt.joltDestroyBody' : 
        (world, idNum) => {
            const id = new world.jolt.BodyID(idNum);
            world.bodyInterface.RemoveBody(id);
            world.bodyInterface.DestroyBody(id);
            world.jolt.destroy(id);
        }
        ,
    'com.awakekt.awake.physics.jolt.joltIsActive' : 
        (world, idNum) => {
            const id = new world.jolt.BodyID(idNum);
            const active = world.bodyInterface.IsActive(id);
            world.jolt.destroy(id);
            return active;
        }
        ,
    'com.awakekt.awake.physics.jolt.joltRemoveConstraint' : 
        (world, constraint) => {
            // No jolt.destroy here: a constraint is ref-counted and RemoveConstraint releases the
            // system's reference. Freeing it by hand double-frees, and in a shared wasm heap that
            // surfaces as unrelated tests failing later rather than as a fault here.
            world.physicsSystem.RemoveConstraint(constraint);
        }
        ,
    'com.awakekt.awake.physics.jolt.joltDrainContacts' : 
        (world) => {
            const out = [world.contacts.length / 3].concat(world.contacts);
            world.contacts.length = 0;
            return out;
        }
        ,
    'com.awakekt.awake.physics.jolt.jsArrayGet' : (arr, index) => arr[index],
    'com.awakekt.awake.physics.jolt.joltGetLinearVelocity' : 
        (world, idNum) => {
            const id = new world.jolt.BodyID(idNum);
            const v = world.bodyInterface.GetLinearVelocity(id);
            world.jolt.destroy(id);
            return [v.GetX(), v.GetY(), v.GetZ()];
        }
        ,
    'com.awakekt.awake.physics.jolt.joltMoveKinematic' : 
        (world, idNum, px, py, pz, qw, qx, qy, qz, deltaTime) => {
            const jolt = world.jolt;
            const id = new jolt.BodyID(idNum);
            const position = new jolt.RVec3(px, py, pz);
            const rotation = new jolt.Quat(qx, qy, qz, qw);
            world.bodyInterface.MoveKinematic(id, position, rotation, deltaTime);
            for (const made of [rotation, position, id]) jolt.destroy(made);
        }
        ,
    'com.awakekt.awake.physics.jolt.joltStep' : (world, deltaTime, collisionSteps) => { world.joltInterface.Step(deltaTime, collisionSteps); },
    'com.awakekt.awake.physics.jolt.joltActiveBodyTransforms' : 
        (world) => {
            const jolt = world.jolt;
            const ids = new jolt.BodyIDVector();
            world.physicsSystem.GetActiveBodies(jolt.EBodyType_RigidBody, ids);
            const out = [ids.size()];
            for (let i = 0; i < ids.size(); i++) {
                const id = ids.at(i);
                const p = world.bodyInterface.GetPosition(id);
                const r = world.bodyInterface.GetRotation(id);
                out.push(
                    id.GetIndexAndSequenceNumber(),
                    p.GetX(), p.GetY(), p.GetZ(),
                    r.GetW(), r.GetX(), r.GetY(), r.GetZ()
                );
            }
            jolt.destroy(ids);
            return out;
        }
        ,
    'com.awakekt.awake.physics.jolt.joltRaycast' : 
        (world, ox, oy, oz, dx, dy, dz, onlyLayer) => {
            const query = world.query;
            query.point.Set(ox, oy, oz);
            query.vector.Set(dx, dy, dz);
            const ray = query.ray;
            ray.mOrigin = query.point;
            ray.mDirection = query.vector;
            const collector = query.rayCollector;
            collector.Reset();
            // A sensor is not solid, so it is not what a ray is stopped by -- the same rule the sweep
            // above follows. A ray ignores no body by id.
            world.ignoreId = -1;
            world.physicsSystem.GetNarrowPhaseQuery().CastRay(
                ray, query.raySettings, collector,
                query.anyBroadPhase, world.layerFilter(onlyLayer),
                query.solidBodies, query.anyShape
            );
            const hit = collector.mHit;
            return collector.HadHit() ? [hit.mFraction, hit.mBodyID.GetIndexAndSequenceNumber()] : null;
        }
        ,
    'com.awakekt.awake.physics.jolt.joltShapeCast' : 
        (world, shapeKind, hx, hy, hz, radius, halfHeight, fx, fy, fz, tx, ty, tz, onlyLayer, ignoreId) => {
            const jolt = world.jolt;
            const query = world.query;
            const shape = world.queryShape(shapeKind, hx, hy, hz, radius, halfHeight);
            query.point.Set(fx, fy, fz);
            const start = jolt.RMat44.prototype.sTranslation(query.point);
            query.vector.Set(tx - fx, ty - fy, tz - fz);
            const cast = new jolt.RShapeCast(shape, query.unitScale, start, query.vector);
            const collector = query.castCollector;
            collector.Reset();
            // Skips sensors as well as the ignored body, and does it inside the query so the collector
            // still reports the nearest body that genuinely blocks. A sensor is not solid, and
            // reporting one turns every trigger volume into an invisible wall.
            world.ignoreId = ignoreId;
            world.physicsSystem.GetNarrowPhaseQuery().CastShape(
                cast, query.castSettings, query.zeroOffset, collector,
                query.anyBroadPhase, world.layerFilter(onlyLayer),
                query.solidBodies, query.anyShape
            );
            const hadHit = collector.HadHit();
            let out = [0, 0, 0, 0, 0, 0, 0, 0, 0];
            if (hadHit) {
                const hit = collector.mHit;
                const point = hit.mContactPointOn2;
                const axis = hit.mPenetrationAxis.Normalized();
                out = [
                    1, hit.mBodyID2.GetIndexAndSequenceNumber(),
                    point.GetX(), point.GetY(), point.GetZ(),
                    -axis.GetX(), -axis.GetY(), -axis.GetZ(),
                    hit.mFraction,
                ];
            }
            jolt.destroy(cast);
            jolt.destroy(shape);
            return out;
        }
        ,
    'com.awakekt.awake.physics.jolt.joltDestroyWorld' : 
        (world) => {
            const jolt = world.jolt;
            for (const made of Object.values(world.query)) jolt.destroy(made);
            for (const made of world.oneLayer.values()) jolt.destroy(made);
            jolt.destroy(world.joltInterface);
            jolt.destroy(world.contactListener);
        }
        ,
    'com.awakekt.awake.physics.jolt.joltCreateWorld' : 
        (jolt, gx, gy, gz, layerCount, collidesFlat, movingFlat) => {
            // Tables built from the world's own matrix rather than hardcoded: `collidesFlat` is the
            // layerCount x layerCount matrix row-major, `movingFlat` says which layers can move and so
            // which broadphase tree they belong in.
            const NUM_BROAD_PHASE_LAYERS = 2;
            const BP_STATIC = 0;
            const BP_MOVING = 1;

            const settings = new jolt.JoltSettings();
            // The same body limit as the other backends; Jolt.js would otherwise allow 10,240.
            settings.mMaxBodies = 65536;
            const objectFilter = new jolt.ObjectLayerPairFilterTable(layerCount);
            for (let a = 0; a < layerCount; a++) {
                for (let b = a; b < layerCount; b++) {
                    if (collidesFlat[a * layerCount + b]) {
                        objectFilter.EnableCollision(a, b);
                    } else {
                        objectFilter.DisableCollision(a, b);
                    }
                }
            }

            const bpInterface = new jolt.BroadPhaseLayerInterfaceTable(layerCount, NUM_BROAD_PHASE_LAYERS);
            for (let i = 0; i < layerCount; i++) {
                const layer = new jolt.BroadPhaseLayer(movingFlat[i] ? BP_MOVING : BP_STATIC);
                bpInterface.MapObjectToBroadPhaseLayer(i, layer);
                jolt.destroy(layer);
            }

            settings.mObjectLayerPairFilter = objectFilter;
            settings.mBroadPhaseLayerInterface = bpInterface;
            settings.mObjectVsBroadPhaseLayerFilter = new jolt.ObjectVsBroadPhaseLayerFilterTable(
                bpInterface, NUM_BROAD_PHASE_LAYERS, objectFilter, layerCount
            );

            const joltInterface = new jolt.JoltInterface(settings);
            jolt.destroy(settings);
            const physicsSystem = joltInterface.GetPhysicsSystem();
            const gravity = new jolt.Vec3(gx, gy, gz);
            physicsSystem.SetGravity(gravity);
            jolt.destroy(gravity);
            const bodyInterface = physicsSystem.GetBodyInterface();

            // Contacts are buffered here rather than delivered as they happen: JoltPhysics.js calls
            // these from inside Update(), so acting on one would re-enter a running simulation.
            // Nothing in this runtime is threaded, so a plain array is all the synchronisation needed
            // -- unlike the JVM and native backends, where Jolt's worker threads make this a lock.
            const world = {
                jolt, joltInterface, physicsSystem, bodyInterface, objectFilter,
                contacts: [], reporting: new Set(),
            };
            const record = (id1, id2, phase) => {
                // Jolt reports every touching pair in the scene, so without this filter a settled pile
                // of crates would buffer an event per pair per step for events nothing reads.
                if (!world.reporting.has(id1) && !world.reporting.has(id2)) return;
                world.contacts.push(id1, id2, phase);
            };
            const listener = new jolt.ContactListenerJS();
            // All four slots are assigned because ContactListenerJS requires them; only the two
            // transitions record anything.
            listener.OnContactValidate = () => jolt.ValidateResult_AcceptAllContactsForThisBodyPair;
            listener.OnContactAdded = (body1, body2) => {
                record(
                    jolt.wrapPointer(body1, jolt.Body).GetID().GetIndexAndSequenceNumber(),
                    jolt.wrapPointer(body2, jolt.Body).GetID().GetIndexAndSequenceNumber(),
                    0
                );
            };
            listener.OnContactPersisted = () => {};
            listener.OnContactRemoved = (subShapePair) => {
                // Removal carries the sub-shape pair and nothing else, and either body may already
                // have been destroyed -- so only ids are read here, never the bodies behind them.
                const pair = jolt.wrapPointer(subShapePair, jolt.SubShapeIDPair);
                record(
                    pair.GetBody1ID().GetIndexAndSequenceNumber(),
                    pair.GetBody2ID().GetIndexAndSequenceNumber(),
                    1
                );
            };
            physicsSystem.SetContactListener(listener);
            world.contactListener = listener;

            // What every query passes and none changes, built once here rather than on every call:
            // a sweep made and freed 13 objects. A query sets the scratch vectors, resets the
            // collector it uses and builds only its shape and cast. joltDestroyWorld frees these.
            world.ignoreId = -1;
            const solidBodies = new jolt.BodyFilterJS();
            // Both callbacks are handed Emscripten POINTERS, not values -- the id form gets a BodyID*,
            // not the id itself, so comparing it to a body id directly never matches and the exclusion
            // silently does nothing. Only running this backend showed that.
            solidBodies.ShouldCollide =
                (bodyId) => jolt.wrapPointer(bodyId, jolt.BodyID).GetIndexAndSequenceNumber() !== world.ignoreId;
            solidBodies.ShouldCollideLocked =
                (body) => !jolt.wrapPointer(body, jolt.Body).IsSensor();
            const query = {
                unitScale: new jolt.Vec3(1, 1, 1),
                zeroOffset: new jolt.RVec3(0, 0, 0),
                point: new jolt.RVec3(0, 0, 0),
                vector: new jolt.Vec3(0, 0, 0),
                halfExtent: new jolt.Vec3(0, 0, 0),
                corner: new jolt.Float3(0, 0, 0),
                ray: new jolt.RRayCast(),
                castSettings: new jolt.ShapeCastSettings(),
                raySettings: new jolt.RayCastSettings(),
                collideSettings: new jolt.CollideShapeSettings(),
                castCollector: new jolt.CastShapeClosestHitCollisionCollector(),
                rayCollector: new jolt.CastRayClosestHitCollisionCollector(),
                overlapCollector: new jolt.CollideShapeAllHitCollisionCollector(),
                anyLayer: new jolt.ObjectLayerFilter(),
                anyBroadPhase: new jolt.BroadPhaseLayerFilter(),
                anyBody: new jolt.BodyFilter(),
                solidBodies,
                anyShape: new jolt.ShapeFilter(),
            };
            // One filter per layer a query has asked for, made the first time it does.
            const oneLayer = new Map();
            // A stationary initial overlap otherwise has no separating axis to normalize.
            query.castSettings.mReturnDeepestPoint = true;
            world.query = query;
            world.oneLayer = oneLayer;
            world.layerFilter = (onlyLayer) => {
                if (onlyLayer < 0) return query.anyLayer;
                let filter = oneLayer.get(onlyLayer);
                if (filter === undefined) {
                    filter = new jolt.SpecifiedObjectLayerFilter(onlyLayer);
                    oneLayer.set(onlyLayer, filter);
                }
                return filter;
            };
            // The caller destroys the shape; a box copies its half extent, so the scratch is free again.
            world.queryShape = (shapeKind, hx, hy, hz, radius, halfHeight) => {
                if (shapeKind === 0) {
                    query.halfExtent.Set(hx, hy, hz);
                    return new jolt.BoxShape(query.halfExtent, 0.05, null);
                }
                return shapeKind === 1
                    ? new jolt.SphereShape(radius, null)
                    : new jolt.CapsuleShape(halfHeight, radius, null);
            };
            return world;
        }
        ,
    'com.awakekt.awake.physics.jolt.initJoltModule_$external_fun' : () => _ref_am9sdC1waHlzaWNz_.default(),
    'kotlinx.io.node.sep_$external_prop_getter' : (_this) => _this.sep,
    'kotlinx.io.getPlatformName' : 
        () => (typeof navigator !== "undefined" && navigator.platform) || "unknown"
    ,
    'kotlinx.io.node.loadBuffer' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:buffer') : null),
    'kotlinx.io.node.loadOs' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:os') : null),
    'kotlinx.io.node.loadPath' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:path') : null),
    'kotlinx.io.node.loadFs' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:fs') : null),
    'io.ktor.utils.io.js.decode' : (decoder, buffer) => { try { return decoder.decode(buffer) } catch(e) { return null } },
    'io.ktor.utils.io.js.tryCreateTextDecoder' : (encoding, fatal) => { try { return new TextDecoder(encoding, { fatal: fatal }) } catch(e) { return null } },
    'io.ktor.utils.io.charsets.toJsArrayImpl' : (x) => new Int8Array(x),
    'io.ktor.util.date.Date_$external_fun' : () => new Date(),
    'io.ktor.util.date.Date_$external_fun_1' : (p0) => new Date(p0),
    'io.ktor.util.date.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'io.ktor.util.date.getUTCDate_$external_fun' : (_this, ) => _this.getUTCDate(),
    'io.ktor.util.date.getUTCDay_$external_fun' : (_this, ) => _this.getUTCDay(),
    'io.ktor.util.date.getUTCFullYear_$external_fun' : (_this, ) => _this.getUTCFullYear(),
    'io.ktor.util.date.getUTCHours_$external_fun' : (_this, ) => _this.getUTCHours(),
    'io.ktor.util.date.getUTCMinutes_$external_fun' : (_this, ) => _this.getUTCMinutes(),
    'io.ktor.util.date.getUTCMonth_$external_fun' : (_this, ) => _this.getUTCMonth(),
    'io.ktor.util.date.getUTCSeconds_$external_fun' : (_this, ) => _this.getUTCSeconds(),
    'io.ktor.util.hasNodeApi' : () => 
    (typeof process !== 'undefined' 
        && process.versions != null 
        && process.versions.node != null) ||
    (typeof window !== 'undefined' 
        && typeof window.process !== 'undefined' 
        && window.process.versions != null 
        && window.process.versions.node != null)
    ,
    'io.ktor.util.logging.getKtorLogLevel' : () => process ? process.env.KTOR_LOG_LEVEL : null,
    'io.ktor.util.logging.warn_$external_fun' : (_this, p0) => _this.warn(p0),
    'io.ktor.util.logging.debug_$external_fun' : (_this, p0) => _this.debug(p0),
    'io.ktor.util.logging.console_$external_prop_getter' : () => console,
    'io.ktor.http.locationOrigin' : () => function() {
        var tmpLocation = null
        if (typeof window !== 'undefined') {
          tmpLocation = window.location
        } else if (typeof self !== 'undefined') {
          tmpLocation = self.location
        }
        var origin = ""
        if (tmpLocation) {
          origin = tmpLocation.origin
        }
        return origin && origin != "null" ? origin : "http://localhost"    
    }(),
    'io.ktor.client.engine.js.createBrowserWebSocket' : (urlString_capturingHack, protocols) => new WebSocket(urlString_capturingHack, protocols),
    'io.ktor.client.engine.js.createWebSocketNodeJs' : (socketCtor, urlString_capturingHack, headers_capturingHack, protocols) => new socketCtor(urlString_capturingHack, protocols, { headers: headers_capturingHack }),
    'io.ktor.client.engine.js.getKeys' : (headers) => Array.from(headers.keys()),
    'io.ktor.client.engine.js.compatibility.abortControllerCtorBrowser' : () => AbortController,
    'io.ktor.client.fetch.body_$external_prop_setter' : (_this, v) => _this.body = v,
    'io.ktor.client.fetch.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
    'io.ktor.client.fetch.method_$external_prop_setter' : (_this, v) => _this.method = v,
    'io.ktor.client.fetch.redirect_$external_prop_setter' : (_this, v) => _this.redirect = v,
    'io.ktor.client.fetch.signal_$external_prop_setter' : (_this, v) => _this.signal = v,
    'io.ktor.client.fetch.signal_$external_prop_getter' : (_this) => _this.signal,
    'io.ktor.client.fetch.abort_$external_fun' : (_this, ) => _this.abort(),
    'io.ktor.client.fetch.fetch_$external_fun' : (p0, p1, isDefault0) => fetch(p0, isDefault0 ? undefined : p1, ),
    'io.ktor.client.fetch.getReader_$external_fun' : (_this, ) => _this.getReader(),
    'io.ktor.client.fetch.cancel_$external_fun' : (_this, p0, isDefault0) => _this.cancel(isDefault0 ? undefined : p0, ),
    'io.ktor.client.fetch.read_$external_fun' : (_this, ) => _this.read(),
    'io.ktor.client.fetch.done_$external_prop_getter' : (_this) => _this.done,
    'io.ktor.client.fetch.value_$external_prop_getter' : (_this) => _this.value,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsString' : (data) => typeof(data) === 'string' ? data : null,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsArrayBuffer' : (data) => data instanceof ArrayBuffer ? data : null,
    'io.ktor.client.utils.makeJsObject' : () => { return {}; },
    'io.ktor.client.utils.makeImport' : (name) => import(name),
    'io.ktor.client.utils.makeJsCall' : (func, arg) => func.apply(null, arg),
    'io.ktor.client.utils.jsObjectAssign' : () => Object.assign,
    'io.ktor.client.utils.makeJsNew' : (ctor) => new ctor(),
    'io.ktor.client.utils.getObjectField' : (obj, name) => obj[name],
    'io.ktor.client.utils.setObjectField' : (obj, name, value) => obj[name]=value,
    'io.ktor.client.utils.eventAsString' : (event) => JSON.stringify(event, ['message', 'target', 'type', 'isTrusted']),
    'io.ktor.client.utils.toJsArrayImpl' : (x) => new Uint8Array(x),
    'com.awakekt.awake.studio.app.currentReturnToParam' : () => { try { return new URLSearchParams(window.location.search).get('returnTo'); } catch (_) { return null; } },
    'com.awakekt.awake.studio.app.installBrowserPlayerPauseHook' : () => {
        if (typeof window === 'undefined' || window.__awakePlayerControl) return;
        const heldFrames = [];
        const nativeRaf = window.requestAnimationFrame.bind(window);
        const control = {
            paused: false,
            mode: 'paused',
            syncUi: null,
            setPaused(next, mode) {
                const nextPaused = Boolean(next);
                control.paused = nextPaused;
                if (nextPaused && mode) {
                    control.mode = mode;
                } else if (!nextPaused) {
                    control.mode = 'paused';
                }
                if (typeof control.syncUi === 'function') {
                    control.syncUi(nextPaused, control.mode);
                }
                if (!nextPaused) {
                    while (heldFrames.length > 0) {
                        const cb = heldFrames.shift();
                        if (cb) nativeRaf(cb);
                    }
                }
            },
        };
        window.__awakePlayerControl = control;
        window.requestAnimationFrame = (cb) => {
            if (control.paused) {
                heldFrames.push(cb);
                return 0;
            }
            return nativeRaf(cb);
        };
        window.addEventListener('message', (e) => {
            if (!e.data) return;
            if (e.data.type === 'awake:player-pause' && typeof e.data.paused === 'boolean') {
                control.setPaused(e.data.paused, e.data.mode || 'paused');
            } else if (e.data.type === 'awake:surface-lost' || e.data.type === 'awake:surface-recovered') {
                control.setPaused(true, 'recovery');
            }
        });
        if (window.parent && window.parent !== window) {
            try { window.parent.postMessage({ type: 'awake:player-ready' }, '*'); } catch (_) {}
        }
    },
    'com.awakekt.awake.studio.app.installBrowserPlayerControls' : (title, gamePath, returnHref, exitLabel) => {
        if (typeof document === 'undefined' || document.getElementById('awake-player-hud')) return;
        const control = window.__awakePlayerControl || {
            paused: false,
            mode: 'paused',
            syncUi: null,
            setPaused(next, mode) {
                this.paused = Boolean(next);
                if (this.paused && mode) this.mode = mode;
                else if (!this.paused) this.mode = 'paused';
                if (this.syncUi) this.syncUi(this.paused, this.mode);
            },
        };
        window.__awakePlayerControl = control;
        const style = document.createElement('style');
        style.textContent = `
            #awake-player-hud {
                position: fixed;
                top: max(12px, env(safe-area-inset-top));
                right: max(12px, env(safe-area-inset-right));
                z-index: 2147483640;
                display: flex; align-items: center; gap: 6px; padding: 6px 10px;
                border-radius: 999px; background: rgba(16, 19, 26, 0.84);
                border: 1px solid rgba(236, 234, 230, 0.16); color: #ECEAE6;
                font: 500 12px/1 system-ui, -apple-system, sans-serif;
                backdrop-filter: blur(8px);
            }
            @media (orientation: landscape) and (max-height: 520px) {
                #awake-player-hud {
                    right: max(44px, env(safe-area-inset-right));
                }
            }
            #awake-player-hud .hud-title {
                max-width: 180px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
                padding: 0 6px; color: #A7A3AD; font-weight: 600;
            }
            #awake-player-hud button, #awake-player-hud a {
                appearance: none; border: 0; background: rgba(236, 234, 230, 0.1);
                color: #ECEAE6; padding: 6px 11px; border-radius: 999px;
                font: inherit; text-decoration: none; cursor: pointer;
                display: inline-flex; align-items: center; justify-content: center;
            }
            @media (pointer: coarse) {
                #awake-player-hud button, #awake-player-hud a {
                    min-height: 44px; padding: 8px 14px;
                }
            }
            #awake-player-hud button:hover, #awake-player-hud a:hover {
                background: rgba(236, 234, 230, 0.2);
            }
            #awake-player-pause-overlay {
                position: fixed; inset: 0; z-index: 2147483639;
                display: none; place-items: center;
                padding: max(16px, env(safe-area-inset-top)) max(16px, env(safe-area-inset-right)) max(16px, env(safe-area-inset-bottom)) max(16px, env(safe-area-inset-left));
                background: rgba(10, 12, 18, 0.78); color: #ECEAE6;
                font: 400 14px/1.5 system-ui, -apple-system, sans-serif;
                backdrop-filter: blur(6px);
            }
            #awake-player-pause-overlay.open { display: grid; }
            #awake-player-pause-overlay .card {
                width: min(380px, 90vw); padding: 24px; border-radius: 16px;
                background: #161822; border: 1px solid rgba(236, 234, 230, 0.16);
                display: grid; gap: 12px; text-align: center;
            }
            #awake-player-pause-overlay .eyebrow {
                justify-self: center; padding: 4px 10px; border-radius: 999px;
                background: rgba(236, 234, 230, 0.08); color: #A7A3AD;
                font-size: 11px; font-weight: 600;
            }
            #awake-player-pause-overlay h2 { margin: 0; font-size: 18px; font-weight: 600; }
            #awake-player-pause-overlay p { margin: 0; font-size: 12px; color: #A7A3AD; }
            #awake-player-pause-overlay .actions { display: grid; gap: 8px; margin-top: 4px; }
            #awake-player-pause-overlay button, #awake-player-pause-overlay a {
                appearance: none; border: 1px solid rgba(236, 234, 230, 0.18);
                background: rgba(236, 234, 230, 0.08); color: #ECEAE6;
                min-height: 40px; padding: 10px 14px; border-radius: 10px; font: 500 13px/1.2 inherit;
                text-decoration: none; cursor: pointer;
                display: inline-flex; align-items: center; justify-content: center;
            }
            #awake-player-pause-overlay button.primary, #awake-player-pause-overlay a.primary {
                background: #FF6B35; border-color: #FF6B35; color: #10131A; font-weight: 600;
            }
            #awake-player-pause-overlay .hidden { display: none !important; }
        `;
        document.head.appendChild(style);
        const hud = document.createElement('div');
        hud.id = 'awake-player-hud';
        hud.setAttribute('role', 'region');
        hud.setAttribute('aria-label', 'Player controls');
        const reportUrl = gamePath + '?report=1';
        const hudTitle = document.createElement('span');
        hudTitle.className = 'hud-title';
        hudTitle.textContent = title;
        const pauseBtn = document.createElement('button');
        pauseBtn.type = 'button';
        pauseBtn.id = 'awake-player-pause-btn';
        pauseBtn.textContent = 'Pause';
        const hudReport = document.createElement('a');
        hudReport.href = reportUrl;
        hudReport.textContent = 'Report';
        const hudExit = document.createElement('button');
        hudExit.type = 'button';
        hudExit.id = 'awake-player-hud-exit-btn';
        hudExit.textContent = 'Exit game';
        hud.append(hudTitle, pauseBtn, hudReport, hudExit);

        const overlay = document.createElement('div');
        overlay.id = 'awake-player-pause-overlay';
        overlay.setAttribute('role', 'dialog');
        overlay.setAttribute('aria-label', 'Game paused');
        const card = document.createElement('div');
        card.className = 'card';
        const eyebrow = document.createElement('span');
        eyebrow.className = 'eyebrow';
        eyebrow.textContent = title;
        const heading = document.createElement('h2');
        heading.id = 'awake-player-overlay-heading';
        const copy = document.createElement('p');
        copy.id = 'awake-player-overlay-copy';
        const actions = document.createElement('div');
        actions.className = 'actions';
        const resumeBtn = document.createElement('button');
        resumeBtn.type = 'button';
        resumeBtn.className = 'primary';
        resumeBtn.id = 'awake-player-resume-btn';
        resumeBtn.textContent = 'Resume game';
        const overlayReport = document.createElement('a');
        overlayReport.id = 'awake-player-report-link';
        overlayReport.href = reportUrl;
        overlayReport.textContent = 'Report Game';
        const overlayExitTrigger = document.createElement('button');
        overlayExitTrigger.type = 'button';
        overlayExitTrigger.id = 'awake-player-exit-trigger';
        overlayExitTrigger.textContent = exitLabel;
        const keepPlayingBtn = document.createElement('button');
        keepPlayingBtn.type = 'button';
        keepPlayingBtn.className = 'primary hidden';
        keepPlayingBtn.id = 'awake-player-keep-playing-btn';
        keepPlayingBtn.textContent = 'Keep playing';
        const confirmExitLink = document.createElement('a');
        confirmExitLink.className = 'hidden';
        confirmExitLink.id = 'awake-player-confirm-exit-link';
        confirmExitLink.href = returnHref;
        confirmExitLink.textContent = exitLabel;
        actions.append(resumeBtn, overlayReport, overlayExitTrigger, keepPlayingBtn, confirmExitLink);
        card.append(eyebrow, heading, copy, actions);
        overlay.appendChild(card);

        document.body.appendChild(hud);
        document.body.appendChild(overlay);
        control.syncUi = (isPaused, mode) => {
            const activeMode = mode || control.mode || 'paused';
            pauseBtn.textContent = isPaused ? 'Resume' : 'Pause';
            overlay.classList.toggle('open', isPaused);
            const isConfirm = activeMode === 'confirm-exit';
            const isRecovery = activeMode === 'recovery';
            if (isConfirm) {
                overlay.setAttribute('aria-label', 'Leave this game?');
                heading.textContent = 'Leave this game?';
                copy.textContent = 'Unfinished actions since your last checkpoint may be lost.';
            } else if (isRecovery) {
                overlay.setAttribute('aria-label', 'Ready to resume');
                heading.textContent = 'Ready to resume';
                copy.textContent = 'The game paused while its surface recovered. Resume from your current checkpoint.';
            } else {
                overlay.setAttribute('aria-label', 'Game paused');
                heading.textContent = 'Game paused';
                copy.textContent = 'Take a moment. Your session stays here. Recent history stays on this device.';
            }
            resumeBtn.classList.toggle('hidden', isConfirm);
            overlayReport.classList.toggle('hidden', isConfirm || isRecovery);
            overlayExitTrigger.classList.toggle('hidden', isConfirm);
            keepPlayingBtn.classList.toggle('hidden', !isConfirm);
            confirmExitLink.classList.toggle('hidden', !isConfirm);
        };
        control.syncUi(control.paused, control.mode);
        pauseBtn.addEventListener('click', () => control.setPaused(!control.paused, 'paused'));
        hudExit.addEventListener('click', () => control.setPaused(true, 'confirm-exit'));
        overlayExitTrigger.addEventListener('click', () => control.setPaused(true, 'confirm-exit'));
        resumeBtn.addEventListener('click', () => control.setPaused(false));
        keepPlayingBtn.addEventListener('click', () => control.setPaused(false));
        window.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') control.setPaused(!control.paused, 'paused');
        });
        if (window.parent && window.parent !== window) {
            try { window.parent.postMessage({ type: 'awake:player-ready' }, '*'); } catch (_) {}
        }
    },
    'com.awakekt.awake.studio.app.jsDecodeUriComponent' : (url) => decodeURIComponent(url),
    'com.awakekt.awake.studio.app.jsOnPageHidden' : (onHidden) => {
        document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') onHidden(); });
        window.addEventListener('pagehide', () => onHidden());
    },
    'com.awakekt.awake.studio.auth.invokeBrowserIdentity' : (apiKey, method, first, second) => {
        const module = globalThis.awakeStudioIdentityModule;
        if (!module) return Promise.reject(new Error('Browser sign-in is unavailable. Open Studio from its website.'));
        return module.then(m => m.createStudioIdentity(apiKey).invoke(method, first, second));
    },
    'com.awakekt.awake.studio.auth.watchBrowserIdentity' : (apiKey, listener) => {
        const handle = { stopped: false, stop: null };
        const module = globalThis.awakeStudioIdentityModule;
        if (module) module.then(m => {
            if (!handle.stopped) handle.stop = m.createStudioIdentity(apiKey).subscribe(listener);
        }).catch(() => {});
        return handle;
    },
    'com.awakekt.awake.studio.auth.stopBrowserIdentity' : (handle) => { handle.stopped = true; if (handle.stop) handle.stop(); },
    'com.awakekt.awake.studio.auth.jsGoogleIdToken' : (clientId) => 
        new Promise((resolve, reject) => {
            const start = () => {
                const overlay = document.createElement('div');
                overlay.style.cssText = 'position:fixed;inset:0;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.45);z-index:10000';
                const box = document.createElement('div');
                overlay.appendChild(box);
                overlay.addEventListener('click', (event) => {
                    if (event.target === overlay) { overlay.remove(); reject(new Error('Sign-in cancelled.')); }
                });
                document.body.appendChild(overlay);
                google.accounts.id.initialize({
                    client_id: clientId,
                    callback: (response) => { overlay.remove(); resolve(response.credential); },
                });
                google.accounts.id.renderButton(box, { theme: 'filled_black', size: 'large', text: 'signin_with' });
            };
            if (window.google && google.accounts && google.accounts.id) { start(); return; }
            const script = document.createElement('script');
            script.src = 'https://accounts.google.com/gsi/client';
            script.async = true;
            script.onload = start;
            script.onerror = () => reject(new Error('Google sign-in could not load.'));
            document.head.appendChild(script);
        })
        ,
    'com.awakekt.awake.studio.files.jsReadHandleFile' : 
    (handle, path) => new Promise(async (resolve, reject) => {
      try {
        const parts = path.split('/').filter(p => p.length > 0);
        let target = handle;
        for (let i = 0; i < parts.length - 1; i++) {
          target = await target.getDirectoryHandle(parts[i]);
        }
        const fh = await target.getFileHandle(parts[parts.length - 1]);
        const file = await fh.getFile();
        resolve(await file.arrayBuffer());
      } catch (err) {
        reject(err);
      }
    })
    ,
    'com.awakekt.awake.studio.files.jsListHandleDirectory' : 
    (handle, subPath, recursive) => new Promise(async (resolve, reject) => {
      try {
        let target = handle;
        if (subPath && subPath !== '/') {
          const parts = subPath.split('/').filter(p => p.length > 0);
          for (const p of parts) {
            target = await target.getDirectoryHandle(p);
          }
        }
        const entries = [];
        async function scan(dir, currentPrefix) {
          for await (const [name, item] of dir.entries()) {
            const itemPath = currentPrefix ? currentPrefix + '/' + name : name;
            if (item.kind === 'file') {
              try {
                const file = await item.getFile();
                entries.push({ path: itemPath, kind: 'File', sizeBytes: file.size, modifiedAtEpochMs: file.lastModified });
              } catch (_) {
                entries.push({ path: itemPath, kind: 'File', sizeBytes: 0, modifiedAtEpochMs: 0 });
              }
            } else if (item.kind === 'directory') {
              entries.push({ path: itemPath, kind: 'Directory', sizeBytes: null, modifiedAtEpochMs: null });
              if (recursive) {
                await scan(item, itemPath);
              }
            }
          }
        }
        await scan(target, subPath && subPath !== '/' ? subPath : '');
        resolve(JSON.stringify(entries));
      } catch (err) {
        reject(err);
      }
    })
    ,
    'com.awakekt.awake.studio.files.jsStatHandle' : 
    (handle, path) => new Promise(async (resolve) => {
      try {
        if (!path || path === '/') {
          resolve(JSON.stringify({ path: '', kind: 'Directory', sizeBytes: null, modifiedAtEpochMs: null }));
          return;
        }
        const parts = path.split('/').filter(p => p.length > 0);
        let target = handle;
        for (let i = 0; i < parts.length - 1; i++) {
          target = await target.getDirectoryHandle(parts[i]);
        }
        const name = parts[parts.length - 1];
        try {
          const fh = await target.getFileHandle(name);
          const f = await fh.getFile();
          resolve(JSON.stringify({ path: path, kind: 'File', sizeBytes: f.size, modifiedAtEpochMs: f.lastModified }));
          return;
        } catch (_) {
          try {
            await target.getDirectoryHandle(name);
            resolve(JSON.stringify({ path: path, kind: 'Directory', sizeBytes: null, modifiedAtEpochMs: null }));
            return;
          } catch (_2) {
            resolve(null);
            return;
          }
        }
      } catch (_) {
        resolve(null);
      }
    })
    ,
    'com.awakekt.awake.studio.files.jsWriteHandleFile' : 
    (handle, path, bytes) => new Promise(async (resolve, reject) => {
      try {
        const parts = path.split('/').filter(p => p.length > 0);
        let target = handle;
        for (let i = 0; i < parts.length - 1; i++) {
          target = await target.getDirectoryHandle(parts[i], { create: true });
        }
        const fh = await target.getFileHandle(parts[parts.length - 1], { create: true });
        const writable = await fh.createWritable();
        await writable.write(bytes.buffer.slice(bytes.byteOffset, bytes.byteOffset + bytes.byteLength));
        await writable.close();
        resolve(null);
      } catch (err) {
        reject(err);
      }
    })
    ,
    'com.awakekt.awake.studio.files.jsCreateHandleDirectories' : 
    (handle, path) => new Promise(async (resolve, reject) => {
      try {
        const parts = path.split('/').filter(p => p.length > 0);
        let target = handle;
        for (const p of parts) {
          target = await target.getDirectoryHandle(p, { create: true });
        }
        resolve(null);
      } catch (err) {
        reject(err);
      }
    })
    ,
    'com.awakekt.awake.studio.files.jsDeleteHandleEntry' : 
    (handle, path, recursive) => new Promise(async (resolve, reject) => {
      try {
        const parts = path.split('/').filter(p => p.length > 0);
        let target = handle;
        for (let i = 0; i < parts.length - 1; i++) {
          target = await target.getDirectoryHandle(parts[i]);
        }
        await target.removeEntry(parts[parts.length - 1], { recursive: recursive });
        resolve(null);
      } catch (err) {
        reject(err);
      }
    })
    ,
    'com.awakekt.awake.studio.files.jsDownload' : (bytes, name) => {
            const url = URL.createObjectURL(new Blob([bytes]));
            const link = document.createElement('a');
            link.href = url;
            link.download = name;
            link.click();
            setTimeout(() => URL.revokeObjectURL(url), 1000);
        },
    'com.awakekt.awake.studio.files.jsSyncEditorHistoryUrl' : (editorLocation) => {
            try {
                if (!globalThis.location || !globalThis.history || typeof globalThis.history.replaceState !== 'function') return;
                const pathname = globalThis.location.pathname || '';
                if (!pathname.startsWith('/web') && !pathname.startsWith('/open')) return;
                const hash = globalThis.location.hash || '';
                globalThis.history.replaceState(null, '', editorLocation + hash);
            } catch (_) {}
        },
    'com.awakekt.awake.studio.files.jsDraftStorageGet' : (key) => { try { return globalThis.localStorage ? globalThis.localStorage.getItem(key) : null; } catch (_) { return null; } },
    'com.awakekt.awake.studio.files.jsDraftStorageSet' : (key, value) => { try { if (globalThis.localStorage) globalThis.localStorage.setItem(key, value); } catch (_) {} },
    'com.awakekt.awake.studio.files.jsNowIsoString' : () => new Date().toISOString()
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        memory: new WebAssembly.Memory({ initial: 0 }),
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
};
    